import { Box } from '@mui/material';
import { usePermissions, useTranslation } from '@hooks';
import { Typography } from '@components/Typography';
import { AUTOMATION_NODE_KIND } from '@constants/automations';
import { NodeIcon } from './nodeMeta';

const GROUPS = [
    {
        key: 'send',
        items: [AUTOMATION_NODE_KIND.SEND_MESSAGE, AUTOMATION_NODE_KIND.SEND_COUPON, AUTOMATION_NODE_KIND.SEND_SURVEY],
    },
    { key: 'flow', items: [AUTOMATION_NODE_KIND.WAIT, AUTOMATION_NODE_KIND.BRANCH] },
];

const KIND_ACCESS = {
    [AUTOMATION_NODE_KIND.SEND_SURVEY]: 'surveys',
    [AUTOMATION_NODE_KIND.SEND_COUPON]: 'coupons',
};

const ActionPalette = ({ onSelect }) => {
    const { t } = useTranslation();
    const { hasAccess } = usePermissions();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {GROUPS.map(group => (
                <Box key={group.key} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="subtitle2" color="textSecondary">
                        {t(`AutomationsPage.palette.${group.key}`)}
                    </Typography>
                    {group.items
                        .filter(kind => !KIND_ACCESS[kind] || hasAccess(KIND_ACCESS[kind]))
                        .map(kind => {
                            return (
                                <Box
                                    key={kind}
                                    onClick={() => onSelect(kind)}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        p: 1,
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        '&:hover': { background: 'var(--action-hover)' },
                                    }}
                                >
                                    <NodeIcon kind={kind} size={36} />
                                    <Box>
                                        <Typography variant="subtitle2">
                                            {t(`AutomationsPage.nodes.${kind}`)}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            {t(`AutomationsPage.paletteHint.${kind}`)}
                                        </Typography>
                                    </Box>
                                </Box>
                            );
                        })}
                </Box>
            ))}
        </Box>
    );
};

export default ActionPalette;
